"use client";
import CustomCarousel from "@/components/CustomCarousel/CustomCarousel.js";
import { wellnessTreatmentCarousel } from "@/utils/data";
import "./wellnessTreatment.scss";
import Image from "next/image";
import Benefits from "@/components/Benefits/Benefits";
import HospitalCarousel from "@/components/HospitalsCarousel/HosptalsCarousel";
import DoctorsCarousel from "@/components/DoctorsCarousel/DoctorsCarousel";
import Treatments from "@/components/Treatments/Treatments";
import Link from "next/link";
import { routeName } from "@/utils/commonfuntions";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";

export default function WellnessTreatment() {
  let allBenefits = [
    {
      benefitsFor: "The Body",
      imgSrc: "/images/bodyWellness.webp",
      features: [
        { heading: "Relaxes", subHeading: "muscles" },
        { heading: "Relieves", subHeading: "pain" },
        { heading: "Improves", subHeading: "blood circulation" },
        { heading: "Revitalizes", subHeading: "Skin, Hair & Nails" },
        { heading: "Enhances", subHeading: "flexibility" },
        { heading: "Fastens", subHeading: "wound healing" },
        { heading: "Reduces", subHeading: "anxiety" },
        { heading: "Boost", subHeading: "immune system" },
        { heading: "Balances", subHeading: "Hormone level" },
        { heading: "Assist", subHeading: "weight management" },
      ],
    },
    {
      benefitsFor: "Brain Function",
      imgSrc: "/images/brain.webp",
      features: [
        { heading: "Improves", subHeading: "cognitive functions" },
        { heading: "Enhances", subHeading: "memory and function" },
        { heading: "Reduces", subHeading: "stress" },
        { heading: "Boosts", subHeading: "creativity" },
        { heading: "Increases", subHeading: "efficiency" },
        { heading: "Lifts", subHeading: "Mood" },
        { heading: "Improves", subHeading: "sleep quality" },
        { heading: "Improves", subHeading: "brain longevity" },
      ],
    },
    {
      benefitsFor: "The Cells",
      imgSrc: "/images/cells.webp",
      features: [
        { heading: "Improves", subHeading: "cellular metabolism" },
        { heading: "Enhances", subHeading: "cellular regneration" },
        { heading: "Boosts", subHeading: "Immune System" },
        { heading: "Reduces", subHeading: "Infammation" },
        { heading: "Improves", subHeading: "absorption" },
        { heading: "Releases", subHeading: "unwanted toxins" },
        {
          heading: "Decreased",
          subHeading: "risk of chronic diseases",
        },
        { heading: "Reduces", subHeading: "cellular aging process" },
      ],
    },
  ];

  return (
    <>
      <BreadCrumbs />
      <div className="wellnessTreatmentWrapper">
        <CustomCarousel itemsPerPage={4}>
          {wellnessTreatmentCarousel.map((treatment, i) => {
            return (
              <div className="treatmentContainer" key={i}>
                <div className="treatmentImgContainer">
                  <Image
                    loading="lazy"
                    src={treatment.img}
                    alt="treatment image"
                    fill
                    sizes="auto"
                  />
                </div>
                <Link
                  href={`/wellnesstreatments/${routeName(treatment.name)}`}
                  className="treatmentBtn"
                >
                  <p className="m-auto">{treatment.name}</p>
                  <Image
                    loading="lazy"
                    src="/images/arrowRight1.svg"
                    alt="arrow right"
                    width={13}
                    height={11}
                  />
                </Link>
              </div>
            );
          })}
        </CustomCarousel>
      </div>
      <Benefits allBenefits={allBenefits} />
      <HospitalCarousel itemsPerPage={4} />
      <DoctorsCarousel itemsPerPage={4} />
      <Treatments numOfRows={1} />
    </>
  );
}
